import React from 'react'
import { Box, Image, VStack } from '@chakra-ui/react'

export interface LayoutEmbedQuizProps {
  imageUrl?: string
  alt: string
}

export const LayoutEmbedQuizPlaylist: React.FC<LayoutEmbedQuizProps> = ({
  children,
  imageUrl = '',
  alt,
}) => {
  return (
    <VStack w={{ base: '100%' }}>
      <Box w={{ base: '100%', md: '60%', sm: '100%' }}>
        <Box h="100%" bg="blackAlpha.700" position="relative">
          <Image
            position="absolute"
            width="100%"
            height="100%"
            objectFit="contain"
            zIndex="-1"
            src={imageUrl || `/images/quiz_bg.png`}
            alt={alt}
            bg="blackAlpha.700"
            filter="blur(2px)"
          />
          <VStack
            w="100%"
            h="100%"
            minHeight="480px"
            justify="center"
            position="relative"
            p="4"
            fontSize={{ base: 'md', sm: 'lg' }}
          >
            {children}
          </VStack>
        </Box>
      </Box>
    </VStack>
  )
}
